import React from 'react';
import { useTranslation } from 'react-i18next';
import Overview from 'Components/Overview';
import { NumberService } from 'Services';
import LinkedRulesCount from '../LinkedRulesCount';

type GenOverview = { id: string; label: string; data: string | number | React.ReactNode; noEllipsis?: boolean };

export const genOverview = (apiData: ListManagementApiList, t: (s: String) => string): GenOverview[] => [
    {
        id: 'listEntries',
        label: t('List Entries'),
        data: NumberService.getLocaleNumber(Number(apiData?.activeListEntriesCount) || 0)
    },
    {
        id: 'listType',
        label: t('List Type'),
        data: apiData?._formatted?.listType
    },
    {
        id: 'linkedRules',
        label: t('Linked Rules'),
        data: <LinkedRulesCount sandboxRules={apiData.sandboxRules} deployedRules={apiData.deployedRules} />,
        noEllipsis: true
    },
    {
        id: 'description',
        label: t('Description'),
        data: apiData?.description
    }
];

const SingleListOverview = ({ data }: { data: ListManagementApiList }) => {
    const { t } = useTranslation();
    const overview = genOverview(data, t);

    return (
        <>
            <Overview
                dataTestId='list-overview'
                leftTitle='List Overview'
                leftData={overview}
                rightData={[
                    {
                        label: t('Last Updated'),
                        data: t('lastUpdatedBy', {
                            date: data._formatted?.modifiedAt,
                            // can be whoevver created/modified it
                            name: data?._formatted?.createdBy
                        })
                    }
                ]}
            />
        </>
    );
};

export default SingleListOverview;
